export default function StatsSection() {
  const stats = [
    { value: '2000+', label: '正版资源', icon: 'ri-database-2-line' },
    { value: '500万+', label: '累计用户', icon: 'ri-user-heart-line' },
    { value: '99.9%', label: '安全通过率', icon: 'ri-shield-check-line' },
    { value: '8大', label: '资源分类', icon: 'ri-grid-line' },
  ];

  return (
    <section className="w-full py-14 md:py-16 px-4 md:px-6 bg-primary-500">
      <div className="max-w-4xl mx-auto">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-white/20 mb-3">
                <i className={`${stat.icon} text-xl text-white`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold text-white mb-1">
                {stat.value}
              </div>
              <div className="text-sm text-white/75">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}